import React from "react"
import News from "../../../blocks/en/news_page"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "sorokins_latvia" }) {
    ...NewsInfoEn
    innerImages {
      callSheet {
        childImageSharp {
          fluid(maxWidth: 1680) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
}`

export default class NewsTextEn extends News {
  renderNews() {
    const { callSheet } = this.props.data.news.innerImages
    return (
      <div className="row">
        <div className="col-xl-12">
          <p><Link to={ `/en/players/sorokins` }>Vladislavs Sorokins</Link> is called up to the Latvia  national team. Our congratulations to Vladislavs and we wish him a great debut!</p>

          <Img fluid={ callSheet.childImageSharp.fluid } alt="Sorokins in Latvia" width="100%" />

        </div>
      </div>
    )
  }
}